var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('dashboard-card',{attrs:{"title":_vm.$t('dashboard.waitingForSign'),"data":_vm.data,"color":"#775DD0"}},[[_c('edit-2-icon',{staticClass:"custom-class",staticStyle:{"stroke":"#775DD0"},attrs:{"size":"1.5x"}})]],2)}
var staticRenderFns = []

export { render, staticRenderFns }